import React from 'react';
import {
  DetailsList,
  SelectionMode,
  DetailsListLayoutMode,
  IDetailsListProps,
  DetailsRow,
  IColumn,
  Text,
  useTheme,
} from '@fluentui/react';
import { Image, ImageFit } from '@fluentui/react/lib/Image';
import PlanillaDigitalForm from './PlanillaDigitalForm';

interface IPlanillaDigitalJugadoresDetailList {
  jugadoresList: any[]; // todocambiar a interface
  addEventForJugador: (ppjId: number) => void;
  getMinuto: () => string;
  form: PlanillaDigitalForm;
  esDiferido: boolean;
  onRefereeReview: boolean;
}

const PlanillaDigitalJugadoresDetailList = ({
  jugadoresList,
  addEventForJugador,
  getMinuto,
  form,
  esDiferido,
  onRefereeReview,
}: IPlanillaDigitalJugadoresDetailList) => {
  const [errorGoles, setErrorGoles] = React.useState(false);
  const [errorAmarillas, setErrorAmarillas] = React.useState(false);
  const [errorSuspensiones, setErrorSuspensiones] = React.useState(false);
  const [errorRojas, setErrorRojas] = React.useState(false);
  const [errorAzules, setErrorAzules] = React.useState(false);

  const jugadorListColumns: IColumn[] = React.useMemo(
    () => [
      {
        key: 'N°',
        fieldName: 'dorsal',
        name: 'N°',
        minWidth: 25,
        maxWidth: 25,
      },
      {
        key: 'Nombre',
        fieldName: 'jug_nombre',
        name: 'Nombre',
        minWidth: 120,
      },
      {
        key: 'Exclusión',
        fieldName: 'exclusion',
        name: '',
        minWidth: 60,
        className: 'index-2',
        onRender: (item) => {
          return !esDiferido && !onRefereeReview ? (
            <div style={{ textAlign: 'center', color: 'rgba(255, 255, 255, 0.9)' }}>{item.exclusion}</div>
          ) : (
            <div></div>
          );
        },
      },
      {
        key: 'Goles',
        fieldName: 'goles',
        name: 'Goles',
        minWidth: 20,
        onRenderHeader: (props) => {
          return (
            <span>
              {!errorGoles ? (
                <Image
                  src={'/img/gol_2.svg'}
                  onError={() => {
                    setErrorGoles(true);
                  }}
                  imageFit={ImageFit.cover}
                  styles={{
                    root: {
                      width: '100%',
                      height: '100%',
                    },
                  }}
                ></Image>
              ) : (
                <Text variant="smallPlus">G</Text>
              )}
            </span>
          );
        },
        onRender: (item) => {
          return <div style={{ textAlign: 'center' }}>{item['goles'] > 0 ? item['goles'] : '-'}</div>;
        },
      },
      {
        key: 'Amarillas',
        fieldName: 'amarillas',
        name: 'Amarillas',
        minWidth: 20,
        onRenderHeader: (props) => {
          return (
            <span>
              {!errorAmarillas ? (
                <Image
                  src={'/img/tarjeta_amarilla.svg'}
                  onError={() => {
                    setErrorAmarillas(true);
                  }}
                  imageFit={ImageFit.cover}
                  styles={{
                    root: {
                      width: '100%',
                      height: '100%',
                    },
                  }}
                ></Image>
              ) : (
                <Text variant="smallPlus">TAm</Text>
              )}
            </span>
          );
        },
        onRender: (item) => {
          return (
            <div className={item.amarillas > 0 ? 'bg-amarilla' : ''} style={{ textAlign: 'center' }}>
              {item.amarillas > 0 ? item.amarillas : '-'}
            </div>
          );
        },
      },
      {
        key: 'Suspensiones',
        fieldName: 'suspensiones',
        name: 'Suspensiones',
        minWidth: 20,
        // isIconOnly: true,
        // iconName: 'UserRemove',
        onRenderHeader: (props) => {
          return (
            <span>
              {!errorSuspensiones ? (
                <Image
                  src={'/img/dos_minutos.svg'}
                  onError={() => {
                    setErrorSuspensiones(true);
                  }}
                  imageFit={ImageFit.cover}
                  styles={{
                    root: {
                      width: '100%',
                      height: '100%',
                    },
                  }}
                ></Image>
              ) : (
                <Text variant="smallPlus">2M</Text>
              )}
            </span>
          );
        },
        onRender: (item) => {
          return (
            <div className={item.suspensiones > 0 ? 'bg-suspensiones' : ''} style={{ textAlign: 'center' }}>
              {item['suspensiones'] > 0 ? item['suspensiones'] : '-'}
            </div>
          );
        },
      },
      {
        key: 'Rojas',
        fieldName: 'rojas',
        name: 'Rojas',
        minWidth: 20,
        // isIconOnly: true,
        // iconName: 'CheckboxFill',
        // iconClassName: 'red-icon',
        onRenderHeader: (props) => {
          return (
            <span>
              {!errorRojas ? (
                <Image
                  src={'/img/tarjeta_roja.svg'}
                  onError={() => {
                    setErrorRojas(true);
                  }}
                  imageFit={ImageFit.cover}
                  styles={{
                    root: {
                      width: '100%',
                      height: '100%',
                    },
                  }}
                ></Image>
              ) : (
                <Text variant="smallPlus">TR</Text>
              )}
            </span>
          );
        },
        onRender: (item) => {
          return (
            <div className={item.rojas > 0 ? 'bg-roja' : ''} style={{ textAlign: 'center' }}>
              {item['rojas'] > 0 ? item['rojas'] : '-'}
            </div>
          );
        },
      },
      {
        key: 'Azules',
        fieldName: 'azules',
        name: 'Azules',
        minWidth: 20,
        // isIconOnly: true,
        // iconName: 'CheckboxFill',
        // iconClassName: 'blue-icon',
        onRenderHeader: (props) => {
          return (
            <span>
              {!errorAzules ? (
                <Image
                  src={'/img/tarjeta_azul.svg'}
                  onError={() => {
                    setErrorAzules(true);
                  }}
                  imageFit={ImageFit.cover}
                  styles={{
                    root: {
                      width: '100%',
                      height: '100%',
                    },
                  }}
                ></Image>
              ) : (
                <Text variant="smallPlus">TAz</Text>
              )}
            </span>
          );
        },
        onRender: (item) => {
          return (
            <div className={item.azules > 0 ? 'bg-azules' : ''} style={{ textAlign: 'center' }}>
              {item['azules'] > 0 ? item['azules'] : '-'}
            </div>
          );
        },
      },
    ],
    [errorGoles, errorAmarillas, errorSuspensiones, errorRojas, errorAzules]
  );

  const getKey = (item: any, index?: number) => {
    return item.key;
  };

  const animationOnClick = (event: React.MouseEvent<HTMLElement>, item?: any): void => {
    const element = event.currentTarget;
    element.classList.add('blink-anim');

    element.addEventListener('animationend', () => animationEnd(element));
  };

  const animationEnd = (element: any) => {
    element.classList.remove('blink-anim');

    element.removeEventListener('animationend', animationEnd);
  };

  const theme = useTheme();
  const _onRenderPlayerRow: IDetailsListProps['onRenderRow'] = (props) => {
    if (props) {
      return (
        <div
          onClick={(e) => {
            addEventForJugador(props.item.ppj_id);
            animationOnClick(e);
          }}
        >
          <DetailsRow
            {...props}
            styles={{
              root: {
                backgroundColor: props.itemIndex % 2 === 0 ? theme.palette.neutralLight : 'transparent',
                selectors: {
                  ':hover': { backgroundColor: theme.palette.neutralQuaternaryAlt },
                },
              },
            }}
            className={
              form.getTiempoRestanteExclusionXJugador(props.item.ppj_id, getMinuto()) &&
              !esDiferido &&
              !onRefereeReview
                ? 'planilla-detail-list exclusion-active'
                : 'planilla-detail-list'
            }
          />
        </div>
      );
    }
    return null;
  };

  return (
    <DetailsList
      items={jugadoresList}
      selectionMode={SelectionMode.none}
      columns={jugadorListColumns}
      setKey="none"
      layoutMode={DetailsListLayoutMode.justified}
      isHeaderVisible={true}
      getKey={getKey}
      onRenderRow={_onRenderPlayerRow}
      onShouldVirtualize={() => false}
    />
  );
};

export default PlanillaDigitalJugadoresDetailList;
